import {
    IS_DROP_DOWNS_LOADING,
    SET_ASSET_READINESS_WORK_BOOK_GRID,
    SET_AUDIT_DATE_LIST,
    SET_AUDIT_READINESS_DATE_LIST,
    SET_AUDIT_TRAINING_DATE_LIST,
    SET_SAVE_ASSET_READINESS_WORK_BOOK,
    SET_IS_WORKBOOK_GRID_BIND_ONLOAD,
    SET_ASSET_READINESS_WORK_BOOK_FILTER,
    SET_CURRENT_AUDIT_CYCLE
} from "./AuditReadinessworkBookType";

const initialState = {
    readinessWorkBookGrid: [],
    isSaveAssetReadinessWorkBook: null,
    auditDateDropDown : [],
    auditReadinessDateDropDown : [],
    auditTrainingDateDropDown : [],
    isWorkBookGridBindOnload: false,
    assetReadinessWorkBookFilter: null,
    auditCycle : {}
}

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_ASSET_READINESS_WORK_BOOK_GRID:
            return {
                ...state,
                readinessWorkBookGrid: action.readinessWorkBookGrid,
            };
        case SET_SAVE_ASSET_READINESS_WORK_BOOK:
            return {
                ...state,
                isSaveAssetReadinessWorkBook: action.isSaveAssetReadinessWorkBook,
            };
        case SET_AUDIT_DATE_LIST :
            return {
                ...state,
                auditDateDropDown : action.auditDateDropDown
            };
        case SET_AUDIT_READINESS_DATE_LIST :
            return {
                ...state,
                auditReadinessDateDropDown : action.auditReadinessDateDropDown
            };
        case SET_AUDIT_TRAINING_DATE_LIST :
            return {
                ...state,
                auditTrainingDateDropDown : action.auditTrainingDateDropDown
                };
        case IS_DROP_DOWNS_LOADING:
            return {
                ...state,
                isDropDownsLoading: action.flag,
            };
        case SET_IS_WORKBOOK_GRID_BIND_ONLOAD:
            return {
                ...state,
                isWorkBookGridBindOnload: action.isWorkBookGridBindOnload,
            };
        case SET_ASSET_READINESS_WORK_BOOK_FILTER:
            return {
                ...state,
                assetReadinessWorkBookFilter: action.assetReadinessWorkBookFilter,
            };
        case SET_CURRENT_AUDIT_CYCLE :
                return {
                    ...state,
                    auditCycle : action.auditCycle
                };
        default:
            return state;
    }
};

export default reducer;
